import React, { Component } from 'react';

class Footer extends Component{
  render() {
    let year =  new Date(Date.now()).getFullYear()
    return (
      <div>
        <footer className="footer">
          Copyright &copy; {year} MYJOULEBOX - V.3.2.01
        </footer>
      </div>
    );
  }
};
export default Footer